<mat-calendar
[(selected)]="selectedDate"
[minDate]="minDate" 
[maxDate]="maxDate"
[dateClass]="dateClass"
(selectedChange)="updateSelectedDate()"></mat-calendar>
